export default "__VITE_ASSET__ac06bec5__"